<template>
  <NextReviewerModal
    ref="modal"
    :asyncSelectOptions="getNextReviewerOptions"
    v-bind="$attrs"
    v-on="$listeners"
    @onOkClick="save"
  >
    <template slot="add-text">
      <dl
        v-if="reviewHistories.length"
        class="tip"
      >
        <dt class="tip__text font-bold">
          {{ $t('tenantProjects.submission.prevReviewerList') }}:
        </dt>
        <dd>
          <ul>
            <li
              v-for="(item, index) in reviewHistories"
              :key="index"
              class="tip__text"
            >
              {{ $t('reviewedBy', [item.displayName, item.date]) }}
            </li>
          </ul>
        </dd>
      </dl>
    </template>
  </NextReviewerModal>
</template>

<script>
import { computed, unref } from '@vue/composition-api'
import { updatePostFitoutSubmission } from '@/api/tenantProjects/postFitout.request'
import NextReviewerModal from '@/controls/Modal/NextReviewerModal'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useStoreActions, useStoreGetters } from '@/store'
import { PermTypeMapKeys } from '@/utils/aclHelper'
import dateUtil from '@/utils/dateUtil'
import { getUsersForSameBuilding } from '../utils'
import { PF_HISTORY_ACTION_TYPE, PF_HISTORY_TYPE } from './consts'
import { useReviewHistories, useUnderReviewPostFitout } from './hook'
import { buildPostFitoutHistory, buildUpdatePostFitoutRequest } from './util'
export default {
  components: {
    NextReviewerModal,
  },
  setup () {
    const { currentTenantProject } = useStoreGetters('tenantProject', ['currentTenantProject'])

    const underReviewPostFitout = useUnderReviewPostFitout()
    const getNextReviewerOptions = async () => {
      const managedBy = unref(underReviewPostFitout).managedBy
      const result = await getUsersForSameBuilding(
        unref(currentTenantProject).tenancy,
        PermTypeMapKeys.TENANT_PROJECT_TECH_SEND,
        { id: managedBy },
        { includeTrReps: true },
      )
      return result.map(item => ({ name: item.displayPicName, value: { id: item.id, username: item.username, email: item.email } }))
    }

    const reviewHistories = computed(() => {
      const result = useReviewHistories(unref(underReviewPostFitout))
      return result.map(item => ({
        displayName: item.createdBy.displayName,
        date: dateUtil.format(item.createdAt, dateUtil.DD_MMM_YY_HH_MM),
      }))
    })

    const modals = useRefModal()
    const postFitoutActions = useStoreActions('postFitoutSubmission', ['getUnderReviewSubmission'])
    const save = async () => {
      const newReviewer = JSON.parse(unref(modals.modal).getSelectedValue())
      const addHistory = buildPostFitoutHistory(PF_HISTORY_TYPE.SUBMISSION, PF_HISTORY_ACTION_TYPE.NEXT_REVIEWER)
      const lock = unref(underReviewPostFitout).lock
      const extraData = { currentManager: unref(underReviewPostFitout).manager, newReviewer }
      const requestBody = buildUpdatePostFitoutRequest({ managedBy: newReviewer.id, lock, extraData }, { addHistory })

      await updatePostFitoutSubmission(unref(underReviewPostFitout).id, requestBody)
      await postFitoutActions.getUnderReviewSubmission()
    }
    return {
      underReviewPostFitout,
      reviewHistories,
      ...modals,
      getNextReviewerOptions,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>
.tip {
  margin-top: 10px;
  dt {
    margin-bottom: 0;
  }
}
li.tip__text {
  list-style: decimal;
}
</style>
